<template>
  <main-page :user="user" color="blue">
    <template v-slot:title> {{ prototype ? "PROTOTYPES" : "PITCHES" }} </template>

    <div class="container">
      <div class="row content">
        <div class="col-12">
          <v-select
            class="vs-big"
            :options="pitchAssignments"
            label="name"
            :clearable="false"
            v-model="selectedAssignment"
            style="width: 300px"
          >
            <template v-slot:selected-option="selectedOption"
              ><div style="height: 30px; overflow: hidden; text-align: left">
                {{ selectedOption.name }}
              </div></template
            >
            <template v-slot:option="option"
              ><div style="overflow: hidden; text-overflow: ellipsis">
                {{ option.name }}
              </div></template
            >
          </v-select>
        </div>
        <div v-for="po in pitchOptions" :key="po.id" class="col-12 col-lg-6">
          <div class="p-3 mt-3 card d-flex flex-row">
            <template v-if="po.pitch">
              <div class="d-flex flex-row align-items-center">
                <img
                  v-if="po.pitch.thumbnail"
                  class="pitch-thumbnail-youtube"
                  :src="po.pitch.thumbnail"
                />
                <img
                  v-if="!po.pitch.thumbnail && !prototype"
                  class="pitch-thumbnail"
                  src="@/assets/images/Video.png"
                />
                <img
                  v-if="!po.pitch.thumbnail && prototype"
                  class="pitch-thumbnail"
                  src="@/assets/images/Prototype.png"
                />
              </div>
              <div class="flex-grow ml-2 p-2 b-l text-left" style="overflow: hidden">
                <div class="si-font text-lg" style="text-overflow: ellipsis">
                  {{ po.team.name }}
                </div>
                <div class="text-extra-muted">
                  {{ fs.medDate(po.pitch.created_at) }}
                </div>
                <div>{{ fs.listNames(po.pitch.students) }}</div>
              </div>
              <div class="pt-2 button-container">
                <a
                  v-if="contextless"
                  class="btn btn-no-border btn-si-green mb-2"
                  :href="`#/${prototype ? 'prototype' : 'pitch'}/${po.pitch.id}`"
                >
                  {{ prototype ? "View Prototype" : "Watch Pitch" }}
                </a>
                <a
                  v-else
                  class="btn btn-no-border btn-si-green mb-2"
                  :href="`#/${prototype ? 'prototype' : 'pitch'}/${po.team.id}/${
                    selectedAssignment.id
                  }`"
                >
                  {{ prototype ? "View Prototype" : "Watch Pitch" }}
                </a>
                <a
                  v-if="
                    (!context.is_contest ||
                      user.role != 'STUDENT' ||
                      program.contest_config.peer_feedback) &&
                    !po.feedback
                  "
                  class="btn btn-no-border btn-si-orange"
                  :href="`#/${prototype ? 'prototype' : 'pitch'}/${po.team.id}/${
                    selectedAssignment.id
                  }?feedback=true`"
                >
                  Provide Feedback
                </a>
                <a
                  v-if="po.feedback && !contextless"
                  class="btn btn-no-border btn-si-blue"
                  :href="`#/${prototype ? 'prototype' : 'pitch'}/${po.team.id}/${
                    selectedAssignment.id
                  }?feedback=true`"
                >
                  Edit Feedback
                </a>
              </div>
            </template>
            <template v-if="!po.pitch">
              <div class="pitch-thumbnail-container" v-if="!context.is_contest && !prototype">
                <img class="pitch-thumbnail" src="@/assets/images/Pitches.png" />
              </div>
              <div
                class="pitch-thumbnail-container"
                v-if="context.is_contest && !prototype"
              >
                <img
                  class="pitch-thumbnail"
                  src="@/assets/images/Pitch_Contest_Icon.png"
                />
              </div>
              <div class="pitch-thumbnail-container" v-if="prototype">
                <img class="pitch-thumbnail" src="@/assets/images/Prototype.png" />
              </div>
              <div class="flex-grow ml-2 p-2 b-l text-left" style="overflow: hidden">
                <div class="si-font text-lg">
                  {{ po.team.name }}
                </div>
                <div class="text-extra-muted">{{ prototype ? "No upload" : "No video" }}</div>
                <div>{{ fs.listNames(po.team.students) }}</div>
              </div>
              <div class="pt-2 button-container">
                <a
                  v-if="
                    (!context.is_contest ||
                      user.role != 'STUDENT' ||
                      program.contest_config.peer_feedback) &&
                    fs.withinWindow(selectedAssignment.start, selectedAssignment.end) &&
                    !po.feedback
                    && !prototype
                  "
                  class="btn btn-no-border btn-si-orange"
                  :href="`#/${prototype ? 'prototype' : 'pitch'}/${po.team.id}/${selectedAssignment.id}?feedback=true`"
                >
                  Live Feedback
                </a>
                <a
                  v-if="
                    (!context.is_contest ||
                      user.role != 'STUDENT' ||
                      program.contest_config.peer_feedback) &&
                    !fs.withinWindow(selectedAssignment.start, selectedAssignment.end)
                  "
                  class="btn btn-no-border btn-si-gray disabled"
                >
                  Unavailable
                </a>
                <a
                  v-if="
                    po.feedback &&
                    fs.withinWindow(selectedAssignment.start, selectedAssignment.end)
                  "
                  class="btn btn-no-border btn-si-blue"
                  :href="`#/${prototype ? 'prototype' : 'pitch'}/${po.team.id}/${selectedAssignment.id}?feedback=true`"
                >
                  Edit Feedback
                </a>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <template v-slot:footer>
      <div class="text-right col-4" v-if="user.role != 'JUDGE'">
        <a v-if="contextless" class="btn btn-si-secondary" :href="'#/score?view=teacher'">Back</a>
        <a v-else class="btn btn-si-secondary" :href="prototype ? '#/prototype_entry' : '#/pitch_entry'">Back</a>
      </div>
    </template>
  </main-page>
</template>

<script>
import MainPage from "@/components/MainPage";

import SectionService from "@/services/SectionService";
import PitchService from "@/services/PitchService";
import ProgramService from "@/services/ProgramService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import BB from "bluebird";
import _ from "lodash";
import moment from "moment";

export default {
  name: "PitchEntry",

  props: ["user"],

  components: { MainPage },

  data() {
    var prototype = false;
    if (this.$route.path.split('/')[1] == "prototypes") {
      prototype = true;
    }
    var contextless = false;
    if (this.$route.params.sectionID && this.user.role == "ADMIN") {
      contextless = true;
    }
    return {
      fs: fs,

      context: null,
      teams: null,
      feedbacks: null,
      pitchOptions: null,
      pitchAssignments: [],
      selectedAssignment: null,
      pitches: null,

      program: null,
      prototype: prototype,
      contextless: contextless,
      sectionID: this.$route.params.sectionID,
    };
  },

  watch: {
    selectedAssignment() {
      console.log("PITCH ASSIGNMENT CHANGED");
      this.constructPitchOptions();
    },
  },

  created() {
    this.loadData();
  },

  methods: {
    loadData() {
      var calls = {}
      if (this.contextless) {
        calls = {
        context: SectionService.getSectionPrefilled(this.sectionID),
        pitches: PitchService.getSectionPitchesPrefilled(this.sectionID),
        feedbacks: PitchService.getSectionFeedbacks(this.sectionID),
        program: ProgramService.getSectionProgram(this.sectionID),
       }
      } else {
        calls = {
        context: SectionService.getContextPrefilled(),
        pitches: PitchService.getContextPitchesPrefilled(),
        feedbacks: PitchService.getMyFeedbacks(),
        program: ProgramService.getContextProgram(),
       }
      }
      BB.props(calls)
        .then((r) => {
          this.loading = false;
          this.context = r.context.data;
          this.teams = this.context.teams;
          this.teams = _.sortBy(this.teams, "name");
          this.pitches = r.pitches.data;
          if (this.prototype) {
            this.pitchAssignments = this.context.prototypes;
          } else {
            this.pitchAssignments = this.context.pitches;
          }
          _.each(this.pitchAssignments, (pa) => {
            pa.due_date = moment(pa.end).endOf("day");
          });
          console.log(this.pitchAssignments);
          this.pitchAssignments = _.sortBy(this.pitchAssignments, "due_date").reverse();
          this.feedbacks = r.feedbacks.data;
          this.program = r.program.data;

          if (this.pitchAssignments && this.pitchAssignments.length > 0) {
            this.selectedAssignment = this.pitchAssignments[0];
          }

          _.each(this.teams, (team) => {
            team.students = _.filter(team.students, (s) => {
              return this.context.student_ids.includes(s.id);
            });
          });

          if (
            this.user.role == "STUDENT" &&
            this.context.is_contest &&
            this.program.contest_config.hide_peer_submissions
          ) {
            this.teams = _.filter(this.teams, (t) => {
              return t.user_ids.includes(this.user.id);
            });
          }
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          Notie.error("Failed to load pitches", e);
        });
    },

    constructPitchOptions() {
      if (!this.selectedAssignment) {
        console.log("NO ASSIGNMENT");
        return;
      }

      let options = [];
      _.each(this.teams, (team) => {
        console.log("process team", team.name);
        let po = {};
        po.team = team;
        po.pitch = _.find(this.pitches, {
          assignment_id: this.selectedAssignment.id,
          team_id: team.id,
        });
        po.feedback = _.find(this.feedbacks, {
          assignment_id: this.selectedAssignment.id,
          team_id: team.id,
        });

        if (this.user.role != "JUDGE" || team.judge_ids.includes(this.user.id)) {
          options.push(po);
        }
      });

      console.log("RETURN OPTIONS", options);
      this.pitchOptions = options;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.pitch-thumbnail {
  height: 120px;
  width: 120px;
}
.pitch-thumbnail-youtube {
  height: 90px;
  width: 120px;
}
.button-container {
  display: flex;
  flex-direction: column;
  width: 170px;
}
.btn-no-border {
  padding: 5px;
}
</style>
